module.exports = require("@material-ui/core/Card");


//////////////////
// WEBPACK FOOTER
// external "@material-ui/core/Card"
// module id = 45
// module chunks = 0